<script setup>
import { computed } from 'vue';
import ButtonV4 from 'next/button/Button.vue';

const props = defineProps({
  paymentMethods: {
    type: Array,
    default: () => [],
  },
  selectedMethod: {
    type: String,
    default: null,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select', 'cancel']);

const getIcon = iconName => {
  const icons = {
    'credit-card': 'i-lucide-credit-card',
    'qr-code': 'i-lucide-qr-code',
    'file-text': 'i-lucide-file-text',
  };
  return icons[iconName] || 'i-lucide-wallet';
};

const isSelected = method => props.selectedMethod === method.id;

const selectMethod = method => {
  emit('select', method.id);
};
</script>

<template>
  <div class="space-y-4">
    <div class="text-center mb-6">
      <h3 class="text-lg font-semibold text-n-slate-12">
        Escolha a forma de pagamento
      </h3>
      <p class="text-sm text-n-slate-10 mt-1">
        Selecione como deseja realizar o pagamento
      </p>
    </div>

    <div class="grid gap-3">
      <button
        v-for="method in paymentMethods"
        :key="method.id"
        class="flex items-center gap-4 p-4 rounded-xl border-2 transition-all text-left"
        :class="[
          isSelected(method)
            ? 'border-woot-500 bg-woot-50 dark:bg-woot-900/20'
            : 'border-n-slate-3 hover:border-n-slate-5 bg-white dark:bg-n-slate-2',
        ]"
        :disabled="isLoading"
        @click="selectMethod(method)"
      >
        <!-- Icon -->
        <div
          class="w-12 h-12 rounded-lg flex items-center justify-center"
          :class="[
            isSelected(method)
              ? 'bg-woot-500 text-white'
              : 'bg-n-slate-3 text-n-slate-11',
          ]"
        >
          <span :class="getIcon(method.icon)" class="text-xl" />
        </div>

        <!-- Info -->
        <div class="flex-1">
          <div class="font-medium text-n-slate-12">{{ method.name }}</div>
          <div class="text-sm text-n-slate-10">{{ method.description }}</div>
        </div>

        <!-- Check -->
        <div
          v-if="isSelected(method)"
          class="w-6 h-6 rounded-full bg-woot-500 flex items-center justify-center"
        >
          <span class="i-lucide-check text-white text-sm" />
        </div>
      </button>
    </div>

    <!-- Actions -->
    <div class="flex gap-3 mt-6">
      <ButtonV4
        class="flex-1"
        faded
        slate
        :disabled="isLoading"
        @click="emit('cancel')"
      >
        Cancelar
      </ButtonV4>
      <ButtonV4
        class="flex-1"
        :disabled="!selectedMethod || isLoading"
        :is-loading="isLoading"
        @click="emit('select', selectedMethod)"
      >
        Continuar
      </ButtonV4>
    </div>
  </div>
</template>
